import React, { useState, useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import axios from "axios";
import _, { parseInt } from "lodash";
import { v4 as uuidv4 } from "uuid";

// component
import { errorSwal, successSwal } from "../../../helper/sweetalert";
import { COLOR_WHITE, JACKSPORT_SHOP_IDS, LINEAR_GRADIENT_BG, S3_URL, SHOP_SETTING_KEY, USER_KEY } from "../../../const";

//apollo
import { GET_PRODUCT_GENBARCODE } from "../../../apollo/product/query";
import { GET_PRESIGN_URL } from "../../../apollo/presignUrl/query";
import { CREATE_PRODUCT_V2 } from "../../../apollo/product/Mutation";
import { GET_CATEGORYS } from "../../../apollo/category/query";
import { GET_SUBBRANDS } from "../../../apollo/subbrand/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_BRANDS } from "../../../apollo/brand/Query";
import { GET_SUVIVALS, GET_UNITS } from "../../../apollo/unit/Query";

// icons
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

// react bootrap
import { Col, Form, InputGroup, Row, Button, Spinner } from "react-bootstrap";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import useWindowDimensions from "../../../helper/windowDimensions";
import { ReactIcons } from "../../../icons";

function AddProduct() {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const historys = useHistory();
  const specificationKeys = [
    { key: "", label: "-----ເລືອກຄຸນລັກສະນະ-----" },
    { key: "Made_in", label: "ຜະລິດໃນ" },
    { key: "Color", label: "ສີ" },
    { key: "Size", label: "ຂະໜາດ" },
    { key: "Material", label: "ວັດຖຸດິບ" },
    { key: "Weight", label: "ນ້ຳໜັກ" },
    { key: "Length", label: "ຄວາມຍາວ" },
    { key: "Width", label: "ຄວາມກ້ວາງ" },
    { key: "Height", label: "ຄວາມສູງ" },
    { key: "Origin", label: "ຕົ້ນກຳເນີດ" },
    { key: "Brand", label: "ແບຣນ" },
    { key: "Model", label: "ຮຸ່ນ" },
    { key: "Warranty", label: "ຮັບປະກັນ" },
    { key: "Battery", label: "ແບັດເຕີຣີ" },
    { key: "Voltage", label: "ແຮງດັນ" },
    { key: "Power", label: "ກຳລັງໄຟ" },
    { key: "Capacity", label: "ຄວາມຈຸ" },
    { key: "Volume", label: "ປະລິມານ" },
    { key: "Package", label: "ໃນກ່ອງ" },
    { key: "Pattern", label: "ລາຍ" },
    { key: "Gender", label: "ເພດ" },
    { key: "Age", label: "ອາຍຸ" },
    { key: "Fabric", label: "ເນື້ອຜ້າ" },
    { key: "Fit", label: "ຮູບຊົງ" },
    { key: "Style", label: "ສະໄຕລ໌" },
    { key: "Usage", label: "ການນຳໃຊ້" },
    { key: "Storage", label: "ການເກັບຮັກສາ" },
    { key: "Shelf_Life", label: "ອາຍຸການເກັບ" },
  ];
  const [category, setCategory] = useState();
  const [brand, setBrand] = useState();
  const [subBrand, setSubBrand] = useState();
  const [unit, setUnit] = useState();
  const [history, setHistory] = useState([]);
  const [isChecked, setIsChecked] = useState(true);
  const [hasVariant, setHasVariant] = useState(false);
  const [searchBrand, setSearchBrand] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [searchSubbrand, setSearchSubbrand] = useState("");
  const [sortNumber, setSortNumber] = useState(0)
  const [selecteUnit, setSelectedUnit] = useState("");
  const [priceOptions, setPriceOptions] = useState([
    { price: 0, contain: "1", unit: "" },
  ]);
  const [genBarCode, setGenBarCode] = useState("");
  const [barcode, setBarCode] = useState();
  const [copyData, setCopyData] = useState({
    name: "",
    priceOptions: [{}],
    amount: "",
    originPrice: "",
    promoPrice: "",
    isPromo: false,
    cfMessage: "",
    currency: "",
    detail: "",
    shortDescription: "",
    description: "",
    note: "",
    size: "",
    barCode: "",
    sku: "",
    brand: "",
    category: "",
    image: "",
    creationDate: "",
    expirationDate: "",
    importDate: "",
    shippingCost: 0,
    priceDisplay: "",
    isUsingSalePage: false,
    isPrinted: false,
    specifications: [{ key: "", value: "" }],
  });
  const [files, setFiles] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const { width } = useWindowDimensions();
  const [formDimension, setFormDimension] = useState({
    length: '',
    width: '',
    height: '',
    weight: ''
  });
  const [survivalDatas, setSurvivalDatas] = useState([]);
  const [selectSurvivalNumber, setSelectSurvivalNumber] = useState("");
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {};
  const commissionEnable = shopSetting?.commissionEnable ?? false;
  const [commissionPlatforms, setCommissionPlatforms] = useState([
    { platform: "POS", commissionType: "FIXED", commissionValue: 0 },
    { platform: "ONLINE", commissionType: "FIXED", commissionValue: 0 }
  ]);

  // ============== > UseLazyQuery And UseMutaion <==============

  const [getCategory, { data: GetCategoryData, loading: loadingCategory }] =
    useLazyQuery(GET_CATEGORYS, { fetchPolicy: "network-only" });
  const [getBrand, { data: GetBrandData, loading: loadingBrand }] =
    useLazyQuery(GET_BRANDS, { fetchPolicy: "network-only" });

  const [LoadSubBrand, { data: GetSubBrandData, loading: loadingSubBrand }] =
    useLazyQuery(GET_SUBBRANDS, { fetchPolicy: "network-only" });

  const [getUnit, { data: GetUnitData, loading: loadingUnit }] = useLazyQuery(
    GET_UNITS,
    { fetchPolicy: "network-only" }
  );

  const [
    LoadGenBarCode,
    { data: GetGenBarCodeData, loading: loadingGenBarCode },
  ] = useLazyQuery(GET_PRODUCT_GENBARCODE, { fetchPolicy: "network-only" });

  const [getSurvivalData, { loading: loadingSurvival, data: survivalDatasLoad, error }] = useLazyQuery(GET_SUVIVALS, {
    fetchPolicy: "cache-and-network"
  });

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  const [createProductV2, { loading: loadingCreate }] =
    useMutation(CREATE_PRODUCT_V2);

  // ============== > UseLazyQuery And UseMutaion <==============
  const handleClearForm = () => {
    setCopyData({
      name: "",
      priceOptions: [{}],
      amount: "",
      originPrice: "",
      promoPrice: "",
      isPromo: false,
      cfMessage: "",
      currency: "",
      detail: "",
      shortDescription: "",
      description: "",
      note: "",
      size: "",
      barCode: "",
      sku: "",
      brand: "",
      category: "",
      image: "",
      priceDisplay: "",
      isUsingSalePage: false,
      isPrinted: false,
      importDate: "",
      specifications: [{ key: "", value: "" }],
    });
    setFormDimension({
      length: '',
      width: '',
      height: '',
      weight: ''
    })
    setCommissionPlatforms([
      { platform: "POS", commissionType: "FIXED", commissionValue: 0 },
      { platform: "ONLINE", commissionType: "FIXED", commissionValue: 0 }
    ]);
    setFiles([]);
    setFileNames([]);
    _loadGenBarCode();
  }

  useEffect(() => {
    _fecthUnit();
    _loadGenBarCode();
  }, []);

  useEffect(() => {
    if (GetCategoryData) {
      setCategory(GetCategoryData?.categories?.data);
    }
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) setBrand(GetBrandData?.brands?.data);
  }, [GetBrandData]);

  useEffect(() => {
    if (GetSubBrandData) {
      const result = [...(GetSubBrandData?.subBrands?.data ?? [])].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setSubBrand(result);
    }
    // console.log("subbarnd======", subBrand);
  }, [GetSubBrandData]);

  useEffect(() => {
    if (GetUnitData) setUnit(GetUnitData?.units?.data);
  }, [GetUnitData]);

  useEffect(() => {
    if (GetGenBarCodeData) {
      const number = GetGenBarCodeData?.products?.total + 1;
      let _genBarCode = number;
      if (number <= 9) _genBarCode = "00000" + _genBarCode;
      else if (number <= 99) _genBarCode = "0000" + _genBarCode;
      else if (number <= 999) _genBarCode = "000" + _genBarCode;
      else if (number <= 9999) _genBarCode = "00" + _genBarCode;
      setGenBarCode(_genBarCode);
    }
  }, [GetGenBarCodeData]);

  // Removed onFileUpload logic from useEffect - handled in handleUpload now

  useEffect(() => {
    // TODO: Get all category
    getCategory({
      variables: {
        limit: 1000,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  }, []);

  useEffect(() => {
    _filter();
    filterBrand();
    filterSubBrand();
  }, [searchBrand, searchCategory, searchSubbrand]);

  // useEffect Hooks
  useEffect(() => {
    const userData = localStorage.getItem("SHOP_DATA");
    if (userData) {
      const locals = JSON.parse(userData);
      if (locals) {
        fetchSurvivalDatas(locals.id);
      }
    }
  }, [])

  useEffect(() => {
    if (survivalDatasLoad) {
      setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
    }
  }, [survivalDatasLoad]);

  // ============== > fuctoions <==============
  const fetchSurvivalDatas = async (shopId) => {
    if (loadingSurvival) return; // Prevent re-triggering if already loading

    try {
      await getSurvivalData({
        variables: {
          where: {
            shop: shopId,
            status: true,
            isDeleted: false
          }
        }
      });
    } catch (err) {
      console.log("Load survival error: ", err);
    }
  }

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (searchCategory !== "") {
      _where = { ..._where, category: searchCategory };
    }

    // TODO: Get all brand
    getBrand({
      variables: {
        limit: 1000,
        where: _where,
      },
    });
  };

  const filterSubBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
      // category: searchCategory
    };
    if (searchBrand !== "") {
      _where = { ..._where, brand: searchBrand };
    }

    // TODO: Get all brand
    LoadSubBrand({
      variables: {
        limit: 1000,
        where: _where,
      },
    });
  };

  const _filter = async () => {
    try {
      // console.log("step 1")
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
        // category: selectCategory
      };

      // TODO: check if search text is not empty

      if (!_.isEmpty(searchBrand) && searchBrand !== "ALL") {
        _where = { ..._where, brand: searchBrand };
      }

      if (!_.isEmpty(searchCategory) && searchCategory !== "ALL") {
        // console.log("step 2")
        _where = { ..._where, category: searchCategory };
      }

      if (!_.isEmpty(searchSubbrand) && searchSubbrand !== "ALL") {
        // console.log("step 2")
        _where = { ..._where, subbrand: searchSubbrand };
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const _loadGenBarCode = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;

    await LoadGenBarCode({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  const _fecthUnit = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await getUnit({
      variables: {
        // limit: 500,
        where: {
          isDeleted: false,
          shop: shopId,
        },
      },
    });
  };

  // ============== > create product <==============

  const handleCreateProductNew = async (values) => {
    try {
      if (loadingCreate) return;
      const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data
        ?.shop?.id;

      const normalizeObjectIdValue = (value) => {
        if (value === null || value === undefined) return undefined;
        if (typeof value !== "string") return value;
        const trimmed = value.trim();
        if (!trimmed || trimmed === "--ເລືອກ--" || trimmed === "ALL") return undefined;
        return trimmed;
      };

      const unitId = normalizeObjectIdValue(selecteUnit);
      const survivalId = normalizeObjectIdValue(selectSurvivalNumber);
      const specifications = (values?.specifications || [])
        .map((item) => ({
          key: (item?.key ?? "").trim(),
          value: (item?.value ?? "").trim(),
        }))
        .filter((item) => item.key);

      if (hasVariant) {
        let data = {
          name: values?.name,
          priceDisplay: values?.priceDisplay,
          category: normalizeObjectIdValue(searchCategory),
          brand: normalizeObjectIdValue(searchBrand),
          cfMessage: values?.cfMessage,
          shortDescription: values?.shortDescription,
          description: values?.description,
          note: values?.note,
          detail: values?.detail,
          shop: shopId,
          hasVariant: true,
          ...(values?.sku ? { sku: values.sku } : {}),
          ...(values?.importDate ? { importDate: values.importDate } : {}),
          ...(specifications.length > 0 ? { specifications } : {}),
          commissionPlatforms: commissionPlatforms.filter(
            (cp) => cp.commissionValue > 0,
          ),
          isUsingSalePage: values?.isUsingSalePage,
          isPrinted: values?.isPrinted,
        };
        if (!_.isEmpty(fileNames)) {
          data = { ...data, image: fileNames };
        }
        await createProductV2({
          variables: {
            data,
          },
        });
      } else {
        let data = {
          ...values,
          ...{ priceOptions: priceOptions },
          barCode: isChecked ? genBarCode : barcode,
          category: normalizeObjectIdValue(searchCategory),
          brand: normalizeObjectIdValue(searchBrand),
          subbrand: normalizeObjectIdValue(searchSubbrand),
          ...(unitId ? { unitId } : {}),
          ...(survivalId ? { survivalId } : {}),
          sort: parseInt(sortNumber),
          amount: parseFloat(
            values.amount ? values?.amount.toString().replace(/,/g, "") : 0
          ),
          originPrice: parseFloat(
            values.originPrice ? values?.originPrice.toString().replace(/,/g, "") : 0
          ),
          promoPrice: parseFloat(
            values.promoPrice ? values?.promoPrice.toString().replace(/,/g, "") : 0
          ),
          isPromo: values.isPromo || false,
          price: priceOptions.length > 0 ? priceOptions[0].price : 0,
          shop: shopId,
          ...(values?.sku ? { sku: values.sku } : {}),
          ...(values?.importDate ? { importDate: values.importDate } : {}),
          ...(specifications.length > 0 ? { specifications } : {}),
          shortDescription: values?.shortDescription,
          description: values?.description,
          note: values?.note,
          dimension: {
            length: parseFloat(
              formDimension.length ? formDimension.length.toString().replace(/,/g, "") : 0
            ),
            width: parseFloat(
              formDimension.width ? formDimension.width.toString().replace(/,/g, "") : 0
            ),
            height: parseFloat(
              formDimension.height ? formDimension.height.toString().replace(/,/g, "") : 0
            ),
            weight: parseFloat(
              formDimension.weight ? formDimension.weight.toString().replace(/,/g, "") : 0
            )
          },
          shippingCost: parseFloat(
            values.shippingCost ? values?.shippingCost.toString().replace(/,/g, "") : 0
          ),
          commissionPlatforms: commissionPlatforms.filter(
            (cp) => cp.commissionValue > 0,
          ),
          isUsingSalePage: values?.isUsingSalePage,
          isPrinted: values?.isPrinted,
        };
        if (!_.isEmpty(fileNames)) {
          data = { ...data, image: fileNames };
        }
        await createProductV2({
          variables: {
            data,
          },
        });
      }
      const historyShowData = [
        ...history,
        { ...values, ...{ priceOptions: priceOptions } },
      ];
      setHistory(historyShowData);

      successSwal("ເພິ່ມສິນຄ້າສຳເລັດແລ້ວ!");
      setTimeout(() => {
        historys.push("/productlist/limit/50/page/1");
      }, 300);
    } catch (err) {
      if (err.message === "PRODUCT_ALREADY_EXIST")
        return errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      errorSwal("ເກີດຂໍ້ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
    }
  };

  const ImageThumb = ({ image, style }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          objectFit: "contain",
          borderRadius: 8,
          height: 300,
          width: 300,
          ...style,
        }}
      />
    );
  };

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
    setFileNames((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSetCover = (index) => {
    if (index === 0) return;

    setFiles((prev) => {
      const newFiles = [...prev];
      const selected = newFiles.splice(index, 1)[0];
      newFiles.unshift(selected);
      return newFiles;
    });

    setFileNames((prev) => {
      const newFileNames = [...prev];
      const selected = newFileNames.splice(index, 1)[0];
      newFileNames.unshift(selected);
      return newFileNames;
    });
  };

  const handleUpload = async (event) => {
    setImageLoading(true);
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length === 0) {
      setImageLoading(false);
      return;
    }

    try {
      for (const file of selectedFiles) {
        const ext = file.name.split(".").pop();
        const filename = uuidv4() + "." + ext;

        const res = await getPresignUrl({
          variables: {
            name: filename,
          },
        });

        const url = res?.data?.preSignedUrl?.url;
        if (url) {
          await axios.put(url, file, {
            headers: {
              "Content-Type": "file/*; image/*",
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            },
          });
          setFiles((prev) => [...prev, file]);
          setFileNames((prev) => [...prev, filename]);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleAddMorePrice = () => {
    const _newPriceOptions = [...priceOptions, { price: 0, contain: "" }];
    setPriceOptions(_newPriceOptions);
  };

  const _handleChangePrie = (value, i) => {
    // Create a new copy of the array with the updated element
    const newArray = [...priceOptions];
    // console.log("newArray: ", newArray)
    newArray[i] = {
      ...newArray[i],
      price: parseFloat(value.toString().replace(/,/g, "")),
    };
    // newArray[i] = parseFloat(value)

    // Use setState to trigger a re-render with the updated data
    setPriceOptions(newArray);
  };

  const _handleChangeContain = (valueContain, iContain) => {
    // Create a new copy of the array with the updated element
    const newArrayContain = [...priceOptions];
    newArrayContain[iContain] = {
      ...newArrayContain[iContain],
      contain: valueContain.toString(),
    };
    // newArray[i] = parseFloat(valueContain)

    // Use setState to trigger a re-render with the updated data
    setPriceOptions(newArrayContain);
  };

  const _handleChangeUnit = (valueUnit, iUnit) => {
    // Create a new copy of the array with the updated element
    const newArrayUnit = [...priceOptions];
    newArrayUnit[iUnit] = {
      ...newArrayUnit[iUnit],
      unit: valueUnit.toString(),
    };
    // newArray[i] = parseFloat(valueContain)

    // Use setState to trigger a re-render with the updated data
    setPriceOptions(newArrayUnit);
  };

  const handleDelete = (i) => {
    const deletVal = [...priceOptions];
    deletVal.splice(i, 1);
    setPriceOptions(deletVal);
  };

  const onCoppy = (his) => {
    setCopyData(his);
    setPriceOptions(his.priceOptions);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleChangAddbarCode = (event) => {
    setBarCode(event.target.value);
  };

  // Dimension
  const handleChangeDimension = (e) => {
    const { name, value } = e.target;
    // Allow numbers with up to 2 decimal places and total length of 7 (4 digits + decimal point + 2 decimal places)
    if (value === '' || /^\d{0,4}(\.\d{0,2})?$/.test(value)) {
      setFormDimension(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleCommissionChange = (index, field, value) => {
    const newCommissions = [...commissionPlatforms];
    if (field === "commissionValue") {
      newCommissions[index][field] =
        parseFloat(value.toString().replace(/,/g, "")) || 0;
    } else {
      newCommissions[index][field] = value;
    }
    setCommissionPlatforms(newCommissions);
  };

  return (
    <>

      <BreadCrumbComponent
        goback={() => historys.goBack()}
        txtFirst="ສາງສິນຄ້າ"
        txtSecond={`ເພິ່ມສິນຄ້າ`}
      />

      <Formik
        enableReinitialize={true}
        initialValues={copyData}
        validate={(values) => {
          const errors = {};
          if (!values.name) {
            errors.name = "ກະລຸນາປ້ອນສິນຄ້າ!";
          }
          if (!hasVariant && !values.isPrinted) {
            if (!values.amount) {
              errors.amount = "ກະລຸນາປ້ອນຈຳນວນກ່ອນ!";
            }
            if (priceOptions[0]?.price <= 0) {
              errors.priceOptions = "ກະລຸນາປອ້ນລາຄາຂາຍ!";
            }
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          handleCreateProductNew(values);
        }}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
        }) => (
          <div style={{ display: "flex", justifyContent: 'start', alignItems: 'start', flexDirection: width > 700 ? "row" : "column", padding: 20 }}>

            <div
              style={{
                width: width > 700 ? "35%" : "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                padding: 10,
              }}
            >
              <div style={{ textAlign: "center" }}>
                <input
                  type="file"
                  id="file-upload"
                  onChange={handleUpload}
                  multiple
                  hidden
                />
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 10,
                    justifyContent: "center",
                  }}
                >
                  {files.map((f, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        width: 150,
                        height: 150,
                        border: index === 0 ? "2px solid #3C169B" : "1px solid #E5E7EB",
                        borderRadius: 8,
                        overflow: "hidden",
                        cursor: index === 0 ? "default" : "pointer",
                      }}
                      onClick={() => handleSetCover(index)}
                    >
                      <ImageThumb
                        image={f}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          opacity: index === 0 ? 1 : 0.8,
                        }}
                      />
                      {index === 0 ? (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            background: "#3C169B",
                            color: "#fff",
                            padding: "2px 6px",
                            fontSize: 10,
                            borderBottomRightRadius: 8,
                            zIndex: 1,
                          }}
                        >
                          ພາບໜ້າປົກ
                        </div>
                      ) : (
                        <div
                          style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: "rgba(0,0,0,0.5)",
                            color: "#fff",
                            fontSize: 10,
                            textAlign: "center",
                            padding: "2px 0",
                          }}
                        >
                          ຕັ້ງເປັນພາບໜ້າປົກ
                        </div>
                      )}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveFile(index);
                        }}
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          background: "rgba(255, 255, 255, 0.8)",
                          borderRadius: "50%",
                          cursor: "pointer",
                          display: "flex",
                          padding: 2,
                          zIndex: 2,
                        }}
                      >
                        <ClearIcon style={{ fontSize: 16, color: "red" }} />
                      </div>
                    </div>
                  ))}

                  <label htmlFor="file-upload" style={{ margin: 0 }}>
                    <div
                      style={{
                        backgroundColor: "#F9FAFB",
                        height: files.length > 0 ? 150 : 300,
                        width: files.length > 0 ? 150 : 300,
                        border: "1px dashed #93989F",
                        borderRadius: 8,
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {imageLoading ? (
                        <>
                          <Spinner
                            animation="border"
                            variant="primary"
                            style={{ color: "#3C169B" }}
                          />
                          <p style={{ color: "#3C169B", marginTop: 10 }}>
                            ກຳລັງອັບໂຫລດ...
                          </p>
                        </>
                      ) : (
                        <>
                          <CloudUploadOutlinedIcon
                            sx={{
                              fontSize: files.length > 0 ? 30 : 50,
                              color: "#93989F",
                            }}
                          />
                          {files.length === 0 && (
                            <>
                              <p style={{ color: "#93989F" }}>ເພີ່ມຮູບສິນຄ້າ</p>
                              <p
                                style={{
                                  color: "#3C169B",
                                  textDecoration: "underline",
                                }}
                              >
                                Browse
                              </p>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </label>
                </div>
                {files.length > 1 && (
                  <p style={{ marginTop: 10, fontSize: 12, color: "#6B7280" }}>
                    ໝາຍເຫດ: ຄລິກທີ່ຮູບທີ່ຕ້ອງການເພື່ອເປັນຮູບປົກ
                  </p>
                )}
              </div>
            </div>

            <div style={{ width: "100%", background: COLOR_WHITE, padding: "2em", borderRadius: 4 }}>
              <Row>
                <Col className={(hasVariant || values.isPrinted) ? "col-12" : "col-6"}>
                  <Form.Label>ຊື່ສິນຄ້າ</Form.Label>
                  <Form.Control
                    name="name"
                    placeholder="ປ້ອນ..."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    style={{
                      border:
                        errors.name && touched.name && errors.name
                          ? "solid 1px red"
                          : "",
                    }}
                  />
                  <small style={{ color: "red" }}>{errors.name}</small>
                </Col>
                {(!hasVariant && !values.isPrinted) && (
                  <>
                    <Col className="col-3">
                      <Form.Label>ລະຫັດບາໂຄ໌ດ</Form.Label>
                      {isChecked ? (
                        <Form.Control
                          name="barcodeadd"
                          aria-label="Default select example"
                          onChange={handleChangAddbarCode}
                          value={barcode}
                          placeholder="ID bar code..."
                          disabled
                        />
                      ) : (
                        <Form.Control
                          name="barcodeadd"
                          aria-label="Default select example"
                          onChange={handleChangAddbarCode}
                          value={barcode}
                          placeholder="ເລກ ID barCode..."
                        />
                      )}
                    </Col>
                    <Col className="col-3">
                      <Form.Label>
                        {" "}
                        <Form.Check
                          aria-label="option 1"
                          value={isChecked}
                          checked={hasVariant === false && isChecked}
                          onChange={handleCheckboxChange}
                          label={`ໂອໂຕ ບາໂຄ໌ດ`}
                        />{" "}
                      </Form.Label>
                      <Form.Control
                        name="barcode"
                        aria-label="Default select example"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={genBarCode}
                        placeholder="ເລກ ID ສິ້ນຄ້າ..."
                        disabled
                      />
                    </Col>
                  </>
                )}
              </Row>
              {/* <Row className="mt-2">
                  <Col className="col-6">
                    <Form.Label>SKU</Form.Label>
                    <Form.Control
                      name="sku"
                      placeholder="SKU..."
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.sku}
                    />
                  </Col>
              </Row> */}
              <br />

              <div>
                {JACKSPORT_SHOP_IDS.includes(shopId) && (
                  <Row className="mt-2">
                    <Col className="col-12">
                      <Form.Check
                        type="switch"
                        id="is-printed-switch"
                        name="isPrinted"
                        label="ສິນຄ້າສັ່ງພິມ (isPrinted)"
                        checked={values.isPrinted}
                        onChange={(e) => {
                          handleChange(e);
                          if (e.target.checked) {
                            setHasVariant(false);
                          }
                        }}
                      />
                    </Col>
                  </Row>
                )}
                {!values.isPrinted && (
                  <>
                    <br />
                    <Row className="mt-2">
                      <Col className="col-12">
                        <Form.Check
                          type="switch"
                          id="create-clothing-product-switch"
                          aria-label="create clothing product"
                          checked={hasVariant}
                          onChange={(e) => {
                          setHasVariant(e.target.checked);
                          if (e.target.checked) {
                            setFieldValue("isPrinted", false);
                          }
                        }}
                          label="ສ້າງສິນຄ້າທີ່ມີຫຼາຍຕົວເລືອກ"
                        />
                      </Col>
                    </Row>
                  </>
                )}
                <br />
                <Row className="mt-2">
                  <Col className="col-12">
                    <Form.Check
                      type="switch"
                      id="is-using-sale-page-switch"
                      name="isUsingSalePage"
                      label="ເປີດຂາຍເທິງ SalePage"
                      checked={values.isUsingSalePage}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              </div>
              <br />

              {/* ===== && ===== */}

              <Row className="mt-2">
                <Col className="col-6">
                  <Form.Label>ປະເພດ</Form.Label>
                  <Form.Select
                    name="category"
                    onChange={(e) => {
                      setSearchCategory(e.target.value);
                    }}
                    value={searchCategory}
                  >
                    <option value="">--ເລືອກ--</option>
                    {category?.map((categorys, index) => (
                      <option key={categorys + index} value={categorys?.id}>
                        {categorys?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col className="col-6 ">
                  <Form.Label>ລະຫັດ CF</Form.Label>
                  <Form.Control
                    name="cfMessage"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.cfMessage}
                    placeholder="ປ້ອນ...."
                  />
                </Col>
                <Col className="col-12 mt-2">
                  <Form.Label>ແບຣນ</Form.Label>
                  <Form.Select
                    name="brand"
                    onChange={(e) => {
                      setSearchBrand(e.target.value);
                    }}
                    value={searchBrand}

                  >
                    <option value="">--ເລືອກ--</option>
                    {brand?.map((brands, index) => (
                      <option key={brands + index} value={brands?.id}>
                        {brands?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                {/* <Col className="col-6 mt-2">
                  <Form.Label>ຊັບແບນ</Form.Label>
                  <Form.Select
                    name="brand"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setSearchSubbrand(e.target.value);
                    }}
                    value={searchSubbrand}>
                    <option value="">--ເລືອກ--</option>
                    {subBrand?.map((sub, index) => (
                      <option key={sub + index} value={sub?.id}>
                        {sub?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col> */}
              </Row>
              <br />

              <Row className="mt-2">
                <Col className="col-4">
                  <Form.Label>ລາຄາສະແດງຜົນ (String)</Form.Label>
                  <Form.Control
                    name="priceDisplay"
                    placeholder="ຕົວຢ່າງ: ລາຄາເລີ່ມຕົ້ນ 100k..."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.priceDisplay}
                    disabled={!(hasVariant || values.isPrinted)}
                  />
                </Col>
              </Row>
              <br />

              {/* ===== && ===== */}
              {(!hasVariant && !values.isPrinted) && (
                <>
                  <Row className="mt-2">
                    <Col className="col-3">
                      <Form.Label>ຈຳນວນ</Form.Label>
                      <NumericFormat
                        name="amount"
                        min={0}
                        className="form-control"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="....."
                        value={values.amount}
                        thousandSeparator={true}
                        prefix={""}

                      />
                      <small style={{ color: "red" }}>{errors.amount}</small>
                    </Col>
                    {/* <Col className="col-3">
                      <Form.Label>ຄ່າຈັດສົ່ງ</Form.Label>
                      <NumericFormat
                        name="shippingCost"
                        min={0}
                        className="form-control"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="ຄ່າຈັດສົ່ງ....."
                        value={values.shippingCost}
                        thousandSeparator={true}
                        prefix={""}

                      />
                      <small style={{ color: "red" }}>{errors.shippingCost}</small>
                    </Col> */}
                    <Col>
                      <Form.Label>ຫົວໜ່ວຍ</Form.Label>
                      <Form.Select
                        name="unitId"
                        aria-label="Default select example"
                        onChange={(e) => setSelectedUnit(e.target.value)}
                        onBlur={handleBlur}
                        value={selecteUnit}
                      >
                        <option value="">--ເລືອກ--</option>
                        {unit?.map((units, keyunit) => (
                          <option key={keyunit} value={units?.id}>
                            {units?.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col className="col-3">
                      <Form.Label>ລາຄາຕົ້ນທືນ</Form.Label>
                      <NumericFormat
                        name="originPrice"
                        min={0}
                        className="form-control"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="ລາຄາສິນຄ້າ..."
                        value={values.originPrice}
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </Col>
                    <Col className="col-3">
                      <Form.Label>ລາຄາໂປຣໂມຊັ່ນ</Form.Label>
                      <div className="d-flex align-items-center gap-2">
                        <NumericFormat
                          name="promoPrice"
                          min={0}
                          className="form-control"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="ລາຄາໂປຣໂມຊັ່ນ..."
                          value={values.promoPrice}
                          thousandSeparator={true}
                          prefix={""}
                        />
                        <Form.Check 
                          type="switch"
                          id="isPromo-switch"
                          name="isPromo"
                          checked={values.isPromo}
                          onChange={handleChange}
                          title="ເປີດໃຊ້ລາຄາໂປຣໂມຊັ່ນ"
                        />
                      </div>
                    </Col>
                    <Col className="col-2">
                      <Form.Label>ສະກຸນເງີນ</Form.Label>
                      <Form.Select
                        name="currency"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.currency}
                        style={{
                          border:
                            errors.currency &&
                              touched.currency &&
                              errors.currency
                              ? "solid 1px red"
                              : "",
                        }}>
                        <option value="">--ເລືອກ--</option>
                        <option value="LAK">ກີບ</option>
                        <option value="BAHT">ບາດ</option>
                        <option value="USD">ໂດລາ</option>
                      </Form.Select>
                      <span style={{ color: "red" }}>{errors.currency}</span>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col className="col-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>ວັນທີຜະລິດ</Form.Label>
                        <Form.Control
                          type="date"
                          name="creationDate"
                          values={values.creationDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="col-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>ວັນທີ່ໝົດອາຍຸ</Form.Label>
                        <Form.Control
                          type="date"
                          name="expirationDate"
                          values={values.expirationDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>
                    <Col className="col-4">
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>ວັນນຳເຂົ້າ</Form.Label>
                        <Form.Control
                          type="date"
                          name="importDate"
                          values={values.importDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col>
                      <Form.Label>ຂະໜາດ</Form.Label>
                      <Form.Control
                        name="size"
                        placeholder="ຂະຫນາດສີນຄ້າ..."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.size}
                      />
                    </Col>
                    <Col>
                      <Form.Label>ລວງຍາວ(cm)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="length"
                        value={formDimension.length}
                        onChange={handleChangeDimension}
                        placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.length}
                      </Form.Control.Feedback>
                    </Col>
                    <Col>
                      <Form.Label>ລວງກ້ວາງ(cm)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="width"
                        value={formDimension.width}
                        onChange={handleChangeDimension}
                        placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.width}
                      </Form.Control.Feedback>
                    </Col>
                    <Col>
                      <Form.Label>ລວງສູງ(cm)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="height"
                        value={formDimension.height}
                        onChange={handleChangeDimension}
                        placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                        aria-label="Length input"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.height}
                      </Form.Control.Feedback>
                    </Col>
                    <Col>
                      <Form.Label>ນ້ຳຫນັກ(kg)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="weight"
                        value={formDimension.weight}
                        onChange={handleChangeDimension}
                        placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.weight}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    {priceOptions.map((price, i) => {
                      return (
                        <>
                          <Form.Group>
                            <Row>
                              <Col>
                                <Form.Label>
                                  ລາຄາຂາຍ
                                  {i === 0
                                    ? ""
                                    : i === 1
                                      ? "2"
                                      : i === 2
                                        ? "3"
                                        : ""}
                                </Form.Label>
                                <InputGroup className="">
                                  <NumericFormat
                                    className="form-control"
                                    min={1}
                                    name="priceOptionsprice"
                                    value={price.price}
                                    thousandSeparator={true}
                                    onChange={(e) => {
                                      if (
                                        parseFloat(price.price) >=
                                        999999999999999
                                      )
                                        return;
                                      _handleChangePrie(e.target.value, i);
                                    }}
                                    style={{
                                      border:
                                        errors.priceOptions &&
                                          touched.priceOptions &&
                                          errors.priceOptions
                                          ? "solid 1px red"
                                          : "",
                                    }}
                                    placeholder="ລາຄາຂາຍສິ້ນຄ້າ..."
                                  />
                                </InputGroup>
                                <small style={{ color: "red" }}>
                                  {errors.priceOptions}
                                </small>
                              </Col>
                              <Col>
                                {i >= 1 ? (
                                  <>
                                    <Form.Label>
                                      ລະບຸຈຳນວນສິນຄ້າຂອງລາຄາ{" "}
                                      {i === 0
                                        ? ""
                                        : i === 1
                                          ? "2"
                                          : i === 2
                                            ? "3"
                                            : ""}
                                    </Form.Label>
                                    <InputGroup className="mb-3">
                                      <Form.Control
                                        name="priceOptionsContain"
                                        placeholder="ປ້ອນ..."
                                        onBlur={handleBlur}
                                        value={price.contain}
                                        onChange={(e) => {
                                          _handleChangeContain(
                                            e.target.value,
                                            i
                                          );
                                        }}
                                      />
                                      {i === 0 ? (
                                        ""
                                      ) : (
                                        <InputGroup.Text
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleDelete(i)}>
                                          <ClearIcon />
                                        </InputGroup.Text>
                                      )}
                                    </InputGroup>
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                              <Col>
                                {i >= 1 ? (
                                  <>
                                    <Form.Label>
                                      ຫົວໜວ່ຍຂອງລາຄາ{" "}
                                      {i === 0
                                        ? ""
                                        : i === 1
                                          ? "2"
                                          : i === 2
                                            ? "3"
                                            : ""}
                                    </Form.Label>
                                    <InputGroup className="mb-3">

                                      <Form.Select
                                        name="priceOptionsUnit"
                                        aria-label="Default select example"
                                        placeholder="ຫົວໝວ່ຍ..."
                                        onBlur={handleBlur}
                                        value={price.unit}
                                        onChange={(e) => {
                                          _handleChangeUnit(e.target.value, i);
                                        }}>
                                        <option value="">--ເລືອກ--</option>
                                        {unit?.map((units, keyunit) => (
                                          <option
                                            key={keyunit}
                                            value={units?.name}>
                                            {units?.name}
                                          </option>
                                        ))}
                                      </Form.Select>
                                      {i === 0 ? (
                                        ""
                                      ) : (
                                        <InputGroup.Text
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleDelete(i)}>
                                          <ClearIcon />
                                        </InputGroup.Text>
                                      )}
                                    </InputGroup>
                                  </>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                          </Form.Group>
                        </>
                      );
                    })}
                    <Col sm={8}></Col>
                    {priceOptions?.length >= 3 ? (
                      ""
                    ) : (
                      <Col sm={4} >
                        <div className="mt-2 d-flex justify-content-end align-items-end w-100">
                          <Button onClick={() => handleAddMorePrice()} variant="outline-secondary" >
                            <AddIcon />
                            ເພີ່ມລາຄາຂາຍ
                          </Button>
                        </div>
                      </Col>
                    )}
                  </Row>

                  <Row className="mt-3">
                    {/* <Col>
                      <Form.Label>ເລກຈັດລຽງສະແດງລຳດັບ</Form.Label>
                      <NumericFormat
                        name="containOptionThird"
                        min={0}
                        className="form-control"
                        onChange={(e) => setSortNumber(e.target.value)}
                        placeholder="ເລກຈັດລຽງ..."
                        value={sortNumber}
                        thousandSeparator={true}
                        prefix={""}
                      />
                    </Col> */}
                    <Col>
                      <Form.Label>ໝາຍເລກລອດ</Form.Label>
                      <Form.Select onChange={(e) => setSelectSurvivalNumber(e?.target?.value)} value={selectSurvivalNumber} aria-label="Default select example">
                        <option value="">--ເລືອກ--</option>
                        {survivalDatas.map((option, indexOption) => (
                          <option key={indexOption} value={option?.id}>{option?.survivalNumber}</option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                </>
              )}

              {!hasVariant && commissionEnable && (
                <Row className="mt-3">
                  <Col xs={12}>
                    <Form.Label style={{ fontWeight: "bold" }}>
                      ຄ່າຄອມມິດຊັ່ນ (Commission)
                    </Form.Label>
                  </Col>
                  {commissionPlatforms.map((commission, index) => (
                    <React.Fragment key={index}>
                      <Col xs={12} md={4}>
                        <Form.Label>
                          {commission.platform === "POS" ? "POS" : "ONLINE"}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          value={commission.platform}
                          disabled
                          style={{ backgroundColor: "#f0f0f0" }}
                        />
                      </Col>
                      <Col xs={12} md={4}>
                        <Form.Label>ປະເພດ</Form.Label>
                        <Form.Select
                          value={commission.commissionType}
                          onChange={(e) =>
                            handleCommissionChange(
                              index,
                              "commissionType",
                              e.target.value,
                            )
                          }
                        >
                          <option value="FIXED">ຈຳນວນເງິນ (FIXED)</option>
                          <option value="PERCENT">
                            ເປີເຊັນ (PERCENT)
                          </option>
                        </Form.Select>
                      </Col>
                      <Col xs={12} md={4}>
                        <Form.Label>
                          ມູນຄ່າ
                          {commission.commissionType === "PERCENTAGE"
                            ? " (%)"
                            : ""}
                        </Form.Label>
                        <NumericFormat
                          className="form-control"
                          value={commission.commissionValue}
                          onChange={(e) =>
                            handleCommissionChange(
                              index,
                              "commissionValue",
                              e.target.value,
                            )
                          }
                          thousandSeparator={true}
                          placeholder="0"
                          min={0}
                        />
                      </Col>
                    </React.Fragment>
                  ))}
                </Row>
              )}
{/* 
              <Row className="mt-3">
                <Col>
                  <Form.Label>ຄໍາອະທິບາຍສັ້ນ</Form.Label>
                  <Form.Control
                    name="shortDescription"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.shortDescription}
                    placeholder="ປ້ອນ..."
                  />
                </Col>
              </Row> */}

              <Row className="mt-3">
                <Col>
                  <Form.Label  style={{fontSize: "12px"}}><span style={{color: "red"}}>*</span> ຂໍ້ມູນສຳລັບສະແດງເທິງ Salepage</Form.Label>
                  <div className="d-flex justify-content-between align-items-center">
                    <Form.Label className="mb-0">ຄຸນລັກສະນະ</Form.Label>
                    <Button
                      variant="outline-secondary"
                      onClick={() =>
                        setFieldValue("specifications", [
                          ...(values.specifications || []),
                          { key: specificationKeys[0]?.key, value: "" },
                        ])
                      }
                    >
                      <AddIcon />
                    </Button>
                  </div>
                  {(values.specifications || []).map((spec, index) => (
                    <Row key={`spec-${index}`} className="mt-2">
                      <Col>
                        <Form.Select
                          value={spec.key || specificationKeys[0]?.key}
                          onChange={(e) => {
                            const next = [...(values.specifications || [])];
                            next[index] = { ...next[index], key: e.target.value };
                            setFieldValue("specifications", next);
                          }}
                        >
                          {specificationKeys.map((keyOption) => (
                            <option key={keyOption.key} value={keyOption.key}>
                              {keyOption.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col>
                        <Form.Control
                          placeholder="ຄ່າ"
                          value={spec.value}
                          onChange={(e) => {
                            const next = [...(values.specifications || [])];
                            next[index] = { ...next[index], value: e.target.value };
                            setFieldValue("specifications", next);
                          }}
                        />
                      </Col>
                      <Col xs="auto">
                        <Button
                          variant="outline-danger"
                          onClick={() => {
                            const next = (values.specifications || []).filter(
                              (_, i) => i !== index,
                            );
                            setFieldValue(
                              "specifications",
                              next.length > 0
                                ? next
                                : [{ key: specificationKeys[0]?.key, value: "" }],
                            );
                          }}
                        >
                          <ClearIcon />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>

              <Row className="mt-3">
                <Col>
                  <Form.Label>ຄໍາອະທິບາຍ</Form.Label>
                  <Form.Control
                    name="description"
                    as="textarea"
                    rows={3}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.description}
                    placeholder="ປ້ອນ..."
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col>
                  <Form.Label>ໝາຍເຫດ</Form.Label>
                  <Form.Control
                    name="note"
                    as="textarea"
                    rows={2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.note}
                    placeholder="ປ້ອນ..."
                  />
                </Col>
              </Row>

              {/* <Row>
                <Col>
                  <Form.Group
                    className="mb-3 mt-3"
                    controlId="exampleForm.ControlTextarea1">
                    <Form.Label>ລາຍລະອຽດເພີ່ມເຕີ່ມ (ຖ້າມີ)</Form.Label>
                    <Form.Control
                      name="detail"
                      as="textarea"
                      placeholder="ປ້ອນ..."
                      rows={3}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.detail}
                    />
                  </Form.Group>
                </Col>
              </Row> */}
              <div style={{ display: "flex", justifyContent: "end", gap: 5 }}>
                <Button variant="outline-secondary" className="px-4"> <ReactIcons.MdCancel /> ຍົກເລີກ</Button>
                <Button variant="light" onClick={() => handleSubmit()} className="px-4" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }}> <ReactIcons.FaCheckCircle /> ບັນທືກ</Button>

              </div>


            </div>


          </div>
        )}
      </Formik>
    </>
  );
}

export default AddProduct;
